import type { ReactElement } from 'react'
import Image from 'next/image'

const ForProSystem = (): ReactElement | null => {

  return (
    <div className="container">
      <h2 className="text-2xl lg:text-3xl font-medium text-center mb-4">
        ONLIVE Studioなら、安心してお仕事を受けられます
      </h2>
      <p className="text-sm sm:text-base text-ghost text-center mb-12">
        全てのクリエイターが安心安全に制作ができる環境を目指しています
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-15">
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/system-1.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-primary mb-3">
            報酬は守られます
          </h3>
          <p className="text-sm sm:text-base leading-tight">
            クライアントからのお支払いは先払いで、プロジェクト完了まで運営が安全にお預かりするので、未払いの心配がありません。
          </p>
        </article>
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-pro/v2/system-2.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-primary mb-3">
            トラブル時は運営がサポート
          </h3>
          <p className="text-sm sm:text-base leading-tight">
            プロジェクト中に困ったことがあれば、運営スタッフがサポートします。お気軽にご相談ください。
          </p>
        </article>
        <article className="flex flex-col items-center">
          <Image
            src="/images/for-artist/v2/problem-3.svg"
            alt=""
            width={60}
            height={60}
            className="mb-4"
          />
          <h3 className="text-base sm:text-xl font-medium text-primary mb-3 text-center">
            音楽に真剣なクライアントが集まる
          </h3>
          <p className="text-sm sm:text-base leading-tight">
            ONLIVE ONLIVE Studioは音楽制作特化型サービス。音楽に真剣なクライアントが集まります。
          </p>
        </article>
      </div>
    </div>
  )
}

export default ForProSystem
